/* eslint-disable prefer-template, newline-before-return, react/jsx-closing-bracket-location, react/jsx-closing-tag-location, indent */
import Layout from "../../../components/Layout";
import useStyles from "../styles";
import useValidator from "../../../hooks/useValidator";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import Button from "../../../components/Button";
import PageTitle from "../../../components/PageTitle";
import BreadCrumb from "../../../components/BreadCrumb";
import { useState, useEffect } from "react";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import { Icon } from "@iconify/react";
import Tabs from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Modal from "../../../components/Modal";
import { Grid, IconButton, Menu, MenuItem, Tooltip } from "@mui/material";
import InputGroup from "../../../components/FormComponent/InputGroup";
import TextAreaGroup from "../../../components/FormComponent/TextAreaGroup";
import Badge from "../../../components/Badge";
import { httprequest } from "../../../data/api";
import { useParams, Link, useSearchParams, useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import WidgetTitle from "../../dashboard/components/WidgetTitle/WidgetTitle";
import Table from "../../../components/Table/Table";
import { TableSearch } from "../../../components/Table/TableActions";
import TestDetailCard from "./TestDetailCard";
import { saveAs } from "file-saver";
import HTMLDocx from "html-docx-js/dist/html-docx";
import RightDrawer from "../../../components/RightDrawer";
import NotFounditem from "../../error/NotFound";
import noexam from "../../../assets/images/noexam.svg";
import { useUserState } from "../../../context/UserContext";
import GenerateQuestionsDrawer from "../../lessonnote/component/GenerateQuestionsDrawer";
import { questionDisplayIndex } from "../../../utils/questionDisplayIndex";

const TEST_ENDPOINT = "/api/v1/ca-test/";
const TEST_CONFIG_ENDPOINT = "/api/v1/test-configs/";
const TEACHER_CLASS_ENDPOINT = "/api/v1/teacher/classes";
const ADMIN_CLASS_ENDPOINT = "/api/v1/class";
const CLASS_SUBJECT_ENDPOINT = "/api/v1/class-subject/";
const TEACHER_SUBJECT_ENDPOINT = "/api/v1/teacher/class-subject/";
const TERM_ENDPOINT = "/api/v1/school-plan/terms";
const SESSION_ENDPOINT = "/api/v1/school-plan/session";
const OBTAINABLE_SCORE_ENDPOINT = "/api/v1/obtainable-score";
const UPLOAD_ENDPOINT = "/api/v1/upload";

function TestEditQuestionsModalContent(props) {
  const {
    editQuestionArr,
    classes,
    questionTypeOptions,
    editQuestionsValidator,
    isUpdatingQuestions,
    onQueChange,
    onQueTypeChange,
    onQuePointChange,
    onCorrectChoiceChange,
    onMultipleChoiceChange,
    onAdditionalOptions,
    onAdditionalQuestion,
    onRemoveQuestion,
    onRemoveChoice,
    onQueDescChange,
    onMenuClick,
    onMenuClose,
    onToggleDescription,
    onRemoveDescription,
    onAddToBankChange,
    editAnchorEl,
    editMenuOpen,
    onUpdate,
    saveButtonLabel = "Save Changes",
    showDraftAndCreateButtons = false,
    onSaveDraft,
    onCreateTest,
    draftButtonLabel = "Save as Draft",
    primaryButtonLabel = "Publish Test",
    editFooterMode = null,
    onEditUpdate,
    onEditPublish,
    onEditWithdraw,
    isEditUpdating = false,
    isEditPublishing = false,
    isEditWithdrawing = false,
    hideAddQuestionInEdit = false,
    onQueImageChange,
    onOptionImageChange,
    onRemoveQueImage,
    onRemoveOptionImage,
    onIconClick,
    onIconOptionClick
  } = props;

  return (
    <>
      <div className="margin-top">
        <Grid container spacing={2}>
          {editQuestionArr?.map((que, queInd) => (
            <Grid item lg={12} md={12} sm={12} xs={12} key={queInd}>
              <div className={classes.assignmentsection}>
                <Grid container spacing={2}>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <div className={classes.quesaction}>
                      <label className={classes.quelabel}>Enter Question {queInd + 1}</label>
                      {editQuestionArr?.length > 1 ? (
                        <Icon icon="material-symbols:delete-outline" width="20" height="20" className="delete-icon" onClick={() => onRemoveQuestion(queInd)} />
                      ) : null}
                    </div>
                    <div className={classes.textandimgmain}>
                      <div className={classes.textandimg}>
                        <input
                          type="text"
                          placeholder={que?.file?.file_url ? "" : "Type Question"}
                          name="question"
                          value={que?.question ?? ""}
                          onChange={(e) => onQueChange(e, queInd)}
                        />
                        {editQuestionsValidator.message(`edit_q_text_${queInd}`, (que?.question ?? "").trim(), "required")}

                        <div onClick={() => onIconClick(`imageInput-${queInd}`)} className={classes.queimg}>
                          <Icon icon="basil:image-outline" width="20" height="20" style={{ color: "#858585" }} />
                          <input
                            type="file"
                            accept="image/*"
                            id={`imageInput-${queInd}`}
                            multiple
                            onChange={(e) => onQueImageChange(e, queInd)}
                            style={{ display: "none" }}
                          />
                        </div>

                        {que?.file?.file_url ? (
                          <div className={classes.preiewcont}>
                            <img src={que.file.file_url} alt="" />
                            <Icon
                              icon="material-symbols:delete-outline"
                              width="20"
                              height="20"
                              className="delete-icon"
                              onClick={() => onRemoveQueImage(queInd)}
                            />
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <SelectGroup label="Add Answer Type" required children={
                      <select name="type" value={que?.type ?? ""} onChange={(e) => onQueTypeChange(e, queInd)}>
                        <option value="">--- Select ---</option>
                        {questionTypeOptions?.map((label) => (
                          <option key={label?.value} value={label?.value}>{label?.text}</option>
                        ))}
                      </select>
                    } />
                    {editQuestionsValidator.message(`edit_q_type_${queInd}`, que?.type, "required")}
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <InputGroup
                      className={classes.pointsInput}
                      label="Question Point"
                      inputType="number"
                      inputName="grade_point"
                      placeHolder="Enter Question Points"
                      value={que?.grade_point ?? ""}
                      onChange={(e) => onQuePointChange(e, queInd)}
                    />
                    {editQuestionsValidator.message(`edit_q_points_${queInd}`, que?.grade_point != null && String(que.grade_point).trim() !== "" ? que.grade_point : null, "required")}
                  </Grid>
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <div className="flex align-items-center gap-10" style={{ marginTop: 8 }}>
                      <input
                        type="checkbox"
                        id={`edit_add_to_bank_${queInd}`}
                        checked={!!que?.add_to_bank}
                        onChange={(e) => onAddToBankChange(e, queInd)}
                      />
                      <label htmlFor={`edit_add_to_bank_${queInd}`} style={{ cursor: "pointer" }}>Add to Question Bank</label>
                    </div>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    {"description" in que && que?.description != null ? (
                      <div className="margin-top full-width">
                        <div className=" flex gap-10 justify-items-space">
                          <label className={classes.enterque}>Question Description</label>
                          <div className="delete-icon" onClick={() => onRemoveDescription(queInd)}>
                            <Icon icon="ooui:close" width="20" height="20" />
                          </div>
                        </div>
                        <div className={classes.textandimgmain}>
                          <input type="text" placeHolder="Enter Description" name="description" value={que?.description ?? ""} onChange={(e) => onQueDescChange(e, queInd)} />
                        </div>
                      </div>
                    ) : null}
                  </Grid>
                </Grid>
                {(que?.type === "multiple_choice" || que?.type === "checkbox" || que?.type === "true_false") && (
                  <Grid container spacing={2} sx={{ marginTop: 1 }}>
                    {(que?.options || []).map((opt, i) => (
                      <Grid item lg={6} md={6} sm={12} xs={12} key={i}>
                        <div>
                          <div className=" flex gap-10 justify-items-space">
                            <label className={classes.enterque}>Option {i + 1}<span className="input-required"> *</span></label>
                            {que?.options?.length > 1 && que?.type !== "true_false" ? (
                              <Icon onClick={() => onRemoveChoice(i, queInd)} className="delete-icon" icon="ooui:close" width="20" height="20" />
                            ) : null}
                          </div>
                          <div className={classes.textandimgmain}>
                            <div className={classes.textandimg}>
                              <input
                                type="text"
                                placeholder="Enter option"
                                value={typeof opt === "object" ? (opt?.text ?? opt?.file_url ?? "") : (opt ?? "")}
                                onChange={(e) => onMultipleChoiceChange(e, i, queInd)}
                                disabled={que?.type === "true_false"}
                              />
                              {que?.type !== "true_false" && (
                                <>
                                  <div onClick={() => onIconOptionClick(`imageInput-${i}${queInd}`)} className={classes.queimg}>
                                    <Icon icon="basil:image-outline" width="20" height="20" style={{ color: "#858585" }} />
                                    <input
                                      type="file"
                                      accept="image/*"
                                      id={`imageInput-${i}${queInd}`}
                                      onChange={(e) => onOptionImageChange(e, i, queInd)}
                                      style={{ display: "none" }}
                                    />
                                  </div>
                                  {typeof opt === "object" && opt?.file_url ? (
                                    <div className={classes.preiewoptioncont}>
                                      <img src={opt.file_url} alt={`Option ${i + 1}`} />
                                      <Icon
                                        icon="material-symbols:delete-outline"
                                        width="20"
                                        height="20"
                                        className="delete-icon"
                                        onClick={() => onRemoveOptionImage(i, queInd)}
                                      />
                                    </div>
                                  ) : null}
                                </>
                              )}
                            </div>
                          </div>
                          <div className="text-align-left" style={{ marginTop: 5 }}>
                            <div className={classes.correctcontainer}>
                              <input
                                type={que?.type === "checkbox" ? "checkbox" : "radio"}
                                name={que?.type === "checkbox" ? "edit-answer" : `edit-answer-${queInd}`}
                                value={i}
                                checked={que?.type === "checkbox" ? (que?.answer || []).includes(i) : (que?.answer || [])[0] === i}
                                onChange={(e) => onCorrectChoiceChange(e, i, queInd)}
                              />
                              <label className={classes.correctlabel}>is correct</label>
                            </div>
                          </div>
                        </div>
                      </Grid>
                    ))}
                  </Grid>
                )}
                {(que?.type === "multiple_choice" || que?.type === "checkbox" || que?.type === "true_false") && (
                  <div style={{ marginTop: 4 }}>
                    {editQuestionsValidator.message(`edit_q_answer_${queInd}`, (que?.answer?.length > 0) ? que.answer : null, "required")}
                  </div>
                )}
                {que?.type === "multiple_choice" && (
                  <div className={classes.addoption} onClick={() => onAdditionalOptions(queInd)}>
                    <Icon icon="octicon:feed-plus-16" width="14" height="14" />
                    <p>Add another option</p>
                  </div>
                )}
                {que?.type === "checkbox" && (
                  <div className={classes.addoption} onClick={() => onAdditionalOptions(queInd)}>
                    <Icon icon="octicon:feed-plus-16" width="14" height="14" />
                    <p>Add another checkbox</p>
                  </div>
                )}
                <div className={classes.questionfooter}>
                  {!que?.description && (
                    <IconButton aria-label="more" onClick={(e) => onMenuClick(e, queInd)}>
                      <Icon icon="radix-icons:dots-vertical" width="20" height="20" />
                      <label className={classes.enterque}>More</label>
                    </IconButton>
                  )}
                </div>
                <Menu anchorEl={editAnchorEl} open={editMenuOpen} onClose={onMenuClose}>
                  <MenuItem onClick={onToggleDescription}>Add Description on Question</MenuItem>
                </Menu>
              </div>
            </Grid>
          ))}
        </Grid>
      </div>
      {!hideAddQuestionInEdit && (
        <div className={classes.addque}>
          <Icon icon="octicon:feed-plus-16" width="16" height="16" />
          <p onClick={onAdditionalQuestion}>Add question</p>
        </div>
      )}
      <div className={classes.btnwrapper}>
        {editFooterMode === "published" ? (
          <Button
            variant="primary"
            color="btndefault"
            buttonSize="fluid"
            buttonName="Withdraw"
            isLoading={isEditWithdrawing}
            onClick={() => onEditWithdraw && onEditWithdraw()}
          />
        ) : editFooterMode === "draft" || editFooterMode === "withdrawn" ? (
          <>
            <Button
              variant="primaryoutline"
              color="btnfontprimary"
              buttonSize="fluid"
              buttonName="Update"
              isLoading={isEditUpdating}
              onClick={() => onEditUpdate && onEditUpdate()}
            />
            <Button
              variant="primary"
              color="btndefault"
              buttonSize="fluid"
              buttonName="Publish questions"
              isLoading={isEditPublishing}
              onClick={() => onEditPublish && onEditPublish()}
            />
          </>
        ) : showDraftAndCreateButtons ? (
          <>
            <Button
              variant="primaryoutline"
              color="btnfontprimary"
              buttonSize="fluid"
              buttonName={draftButtonLabel}
              isLoading={isUpdatingQuestions}
              onClick={onSaveDraft}
            />
            <Button
              variant="primary"
              color="btndefault"
              buttonSize="fluid"
              buttonName={primaryButtonLabel}
              isLoading={isUpdatingQuestions}
              onClick={onCreateTest}
            />
          </>
        ) : (
          <Button
            variant="primary"
            color="btndefault"
            buttonSize="fluid"
            buttonName={saveButtonLabel}
            isLoading={isUpdatingQuestions}
            onClick={onUpdate}
          />
        )}
      </div>
    </>
  );
}

const TestDetail = () => {
  const classes = useStyles();
  const { userRole } = useUserState();
  const isTeacher = userRole?.role_type === "employee";
  const isAdmin = userRole?.role_type === "school_admin";
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [messageModal, setMessageModal] = useState(false);
  const [addreportModal, setReportModal] = useState(false);
  const [testDetailData, setTestDetailData] = useState([]);
  const [value, setValue] = useState("1");
  const [testAttendees, setTestAttendees] = useState([]);
  const [attendeeFilter, setAttendeeFilter] = useState([]);
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);
  const [isGenerateDrawerOpen, setIsGenerateDrawerOpen] = useState(false);
  const [isAddQuestionModalOpen, setIsAddQuestionModalOpen] = useState(false);
  const [isEditQuestionsModalOpen, setIsEditQuestionsModalOpen] = useState(false);
  const [isMetadataDrawerOpen, setIsMetadataDrawerOpen] = useState(false);
  const [editQuestionArr, setEditQuestionArr] = useState([]);
  const [isUpdatingQuestions, setIsUpdatingQuestions] = useState(false);
  const [isPublishingEditQuestions, setIsPublishingEditQuestions] = useState(false);
  const [isWithdrawingEditQuestions, setIsWithdrawingEditQuestions] = useState(false);
  const [addQuestionArr, setAddQuestionArr] = useState([]);
  const [isAddingQuestions, setIsAddingQuestions] = useState(false);
  const [addQuestionsValidator, showAddQuestionsValidator] = useValidator();
  const [editAnchorEl, setEditAnchorEl] = useState(null);
  const [currentAnchor, setCurrentAnchor] = useState(null);
  const [metadataForm, setMetadataForm] = useState({
    title: "",
    description: "",
    instruction: "",
    class_id: "",
    class_name: "",
    subject_id: "",
    subject_name: "",
    session_id: "",
    term_id: "",
    term_name: "",
    ca_type: "",
    duration: "",
    test_date: "",
    random_question: "no",
    randomize_options: "no",
    display_score_after_exam: "no",
    question_display_mode: "",
    proctoring_requirements: "",
    browser_lockdown: false,
    is_private: false
  });
  const [editConfigValidator, showEditConfigValidator] = useValidator();
  const hasQuestions = (testDetailData?.questions?.length ?? 0) > 0;
  const editMenuOpen = Boolean(editAnchorEl);
  const [editQuestionsValidator, showEditQuestionsValidator] = useValidator();
  const [classData, setClassData] = useState([]);
  const [allClassSubject, setAllClassSubject] = useState([]);
  const [allTerm, setAllTerm] = useState([]);
  const [sessionData, setSessionData] = useState([]);
  const [obtainableScore, setObtainableScore] = useState([]);
  const [allObtainableScores, setAllObtainableScores] = useState([]);

  const makeTestImageHandlers = (arrState, setArrState) => {
    const handleQuestionImageChange = async (event, queInd) => {
      if (event?.target?.files?.length > 0) {
        const file = event.target.files[0];
        const formData = new FormData();
        formData.append("file", file);
        try {
          const response = await httprequest.post(UPLOAD_ENDPOINT, formData);
          if (response?.status === 200 && response?.data?.data?.[0]?.file_url) {
            const uploadedImageDetails = {
              upload_id: response?.data?.data?.[0]?.upload_id,
              file_url: response?.data?.data?.[0]?.file_url
            };
            setArrState((prev) => prev.map((q, idx) => idx === queInd ? { ...q, file: uploadedImageDetails } : q));
            toast.success(`Image added to question ${queInd + 1}`);
          } else {
            toast.error(response?.data);
          }
        } catch (error) {
          toast.error(error?.response?.message);
        }
      }
    };
    const handleOptionImageChange = async (event, optionIndex, queInd) => {
      if (event?.target?.files?.length > 0) {
        const file = event.target.files[0];
        const formData = new FormData();
        formData.append("file", file);
        try {
          const response = await httprequest.post(UPLOAD_ENDPOINT, formData);
          if (response?.status === 200 && response?.data?.data?.[0]?.file_url) {
            const uploadedImageDetails = {
              upload_id: response.data.data[0].upload_id,
              file_url: response.data.data[0].file_url
            };
            setArrState((prev) => prev.map((q, qIndex) => {
              if (qIndex === queInd) {
                const updatedOptions = q.options.map((opt, oIndex) => oIndex === optionIndex ? uploadedImageDetails : opt);
                return { ...q, options: updatedOptions };
              }
              return q;
            }));
            toast.success(`Image added to option ${optionIndex + 1} in question ${queInd + 1}`);
          } else {
            toast.error(response?.data);
          }
        } catch (error) {
          toast.error(error?.response?.message);
        }
      }
    };
    const removeQueImage = async (queInd) => {
      const upload_id = arrState[queInd]?.file?.upload_id;
      if (!upload_id) {
        toast.error("No upload ID found for this question");
        return;
      }
      try {
        const response = await httprequest.delete(`${UPLOAD_ENDPOINT}/${upload_id}`);
        if (response?.status === 200) {
          setArrState((prev) => prev.map((q, idx) => idx === queInd ? { ...q, file: { upload_id: "", file_url: "" } } : q));
          toast.success(`Image removed from question ${queInd + 1}`);
        } else {
          toast.error(response?.data);
        }
      } catch (error) {
        toast.error(error?.response?.message);
      }
    };
    const removeOptionImage = async (optionIndex, queInd) => {
      const option = arrState[queInd]?.options?.[optionIndex];
      const upload_id = option?.upload_id;
      if (!upload_id) {
        toast.error("No upload ID found for this option");
        return;
      }
      try {
        const response = await httprequest.delete(`${UPLOAD_ENDPOINT}/${upload_id}`);
        if (response?.status === 200) {
          setArrState((prev) => prev.map((q, qIndex) => {
            if (qIndex === queInd) {
              const updatedOptions = q.options.map((opt, oIndex) => oIndex === optionIndex ? { ...opt, upload_id: "", file_url: "" } : opt);
              return { ...q, options: updatedOptions };
            }
            return q;
          }));
          toast.success(`Option ${optionIndex + 1} image removed successfully`);
        } else {
          toast.error(response?.data);
        }
      } catch (error) {
        toast.error(error?.response?.message);
      }
    };
    return { handleQuestionImageChange, handleOptionImageChange, removeQueImage, removeOptionImage };
  };

  const addImageHandlers = makeTestImageHandlers(addQuestionArr, setAddQuestionArr);
  const editImageHandlers = makeTestImageHandlers(editQuestionArr, setEditQuestionArr);

  const handleIconSharedClick = (idStr) => {
    document.getElementById(idStr).click();
  };

  /**
 * Handles tab change events.
 * @param {Event} event - The change event object.
 * @param {string|number} newValue - The new value of the selected tab.
 */
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  /**
 * Columns configuration for the test attendees table.
 * @type {Array<Object>}
 * @property {string} name - The column header name.
 * @property {function} selector - Function to extract data for the column from each row.
 * @property {boolean} [center] - Whether to center-align the column content.
 * @property {boolean} [sortable] - Whether the column is sortable.
 * @property {function} [cell] - Custom cell renderer function.
 */
  const columns = [
    {
      name: "Student Name",
      selector: row => row?.student?.name
    },
    {
      name: "Class Name",
      selector: row => row?.class?.name
    },
    {
      name: "Status",
      selector: row => <Badge status={row?.status} />
    },
    {
      name: "Submission",
      center: true,
      sortable: false,
      cell: (row) => (
        <div key={row?.submission_id} className="table-action-container">
          <Link to={`/assignment/submission/${row?.submission_id}`} className="table-action-icon">
            <Icon icon="fluent:eye-16-regular" />
          </Link>
        </div>
      )
    }
  ];

  /**
 * Toggles the message modal visibility state.
 */
  const handleMessageModal = () => {
    setMessageModal(!messageModal);
  };

  /**
 * Toggles the report modal visibility state.
 */
  const handleReportModal = () => {
    setReportModal(!addreportModal);
  };

  /**
 * Fetches test details by ID from the API.
 * @async
 */
  const getTestByID = () => {
    httprequest.get(`${TEST_ENDPOINT}${id}`).then((res) => {
      const raw = res?.data?.data;
      const config = raw?.config ?? null;

      // Supports both new (flat) and legacy (config-wrapped) response shapes
      if (config) {
        setTestDetailData((prev) => ({
          ...prev, // Keep manually updated UI fields if they exist
          ...raw,
          ...config,
          id: raw?.id ?? config?.id,
          test_config_id: raw?.test_config_id ?? config?.id ?? raw?.config_id,
          instruction: config?.instructions ?? config?.instruction ?? raw?.instruction ?? raw?.instructions ?? "",
          questions: raw?.questions ?? config?.questions ?? [],
          // Prioritize populated relations from previous state if they match the config's IDs (since backend ca_test might have stale relations)
          class: (prev?.class?.id === config?.class_id) ? prev.class : raw?.class,
          subject: (prev?.subject?.id === config?.subject_id) ? prev.subject : raw?.subject,
          term: (prev?.term?.id === config?.term_id) ? prev.term : raw?.term,
          session: (prev?.session?.id === config?.session_id) ? prev.session : raw?.session
        }));
      } else {
        setTestDetailData({
          ...raw,
          id: raw?.id,
          test_config_id: raw?.test_config_id ?? raw?.config_id,
          instruction: raw?.instruction ?? raw?.instructions ?? "",
          questions: raw?.questions ?? []
        });
      }
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };

  /**
 * Fetches students who have taken the test from the API.
 * @async
 */
  const getTestRecipients = () => {
    httprequest.get(`${TEST_ENDPOINT}/students/${id}`).then((res) => {
      setTestAttendees(res?.data?.data);
      setAttendeeFilter(res?.data?.data);
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };

  const fetchClasses = () => {
    const endpoint = isTeacher ? TEACHER_CLASS_ENDPOINT : ADMIN_CLASS_ENDPOINT;
    httprequest
      .get(endpoint)
      .then((res) => {
        const list = res?.data?.data || [];
        const mapped = isTeacher
          ? list.map((item) => ({ id: item?.class?.id, class_name: item?.class?.name }))
          : list.map((item) => ({ id: item?.id, class_name: item?.class_name }));
        setClassData(mapped.filter((item) => item?.id));
      })
      .catch(() => {});
  };

  const getSubjectsForClass = (classId) => {
    if (!classId) {
      setAllClassSubject([]);
      return;
    }
    const endpoint = isTeacher ? TEACHER_SUBJECT_ENDPOINT : CLASS_SUBJECT_ENDPOINT;
    httprequest
      .get(`${endpoint}${classId}`)
      .then((res) => {
        const list = res?.data?.data || [];
        const mapped = isTeacher
          ? list.map((item) => ({ id: item?.subject?.id, name: item?.subject?.name }))
          : list.map((item) => ({ id: item?.subject_id, name: item?.subject_name }));
        setAllClassSubject(mapped.filter((item) => item?.id));
      })
      .catch(() => {
        setAllClassSubject([]);
      });
  };

  const getAllSessionAndTerms = () => {
    httprequest
      .get(SESSION_ENDPOINT)
      .then((res) => {
        const sessions = res?.data?.data || [];
        setSessionData(sessions);
        const activeSession = sessions.find((s) => s?.current_session === true);
        return httprequest.get(TERM_ENDPOINT).then((termsRes) => {
          const terms = termsRes?.data?.data || [];
          setAllTerm(terms);
          return activeSession?.id;
        });
      })
      .then((activeSessionId) => {
        return httprequest.get(OBTAINABLE_SCORE_ENDPOINT).then((scoreRes) => {
          const scoreData = scoreRes?.data?.data || [];
          setAllObtainableScores(scoreData);
          const found = scoreData.find((item) => item?.session?.id === activeSessionId);
          setObtainableScore(found || []);
        });
      })
      .catch(() => {});
  };

  /**
 * Filters attendees table by student name based on search input.
 * @param {Event} e - The input change event.
 */
  const handleSearchTestByClass = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = testAttendees?.filter((data) => valArray?.every(
      (word) => data?.student_name
        ?.toLowerCase()
        .includes(word.toLowerCase())
    )
    );
    setAttendeeFilter(result);
  };

  /**
   * Convert UTC date string to local date string
   * @param {*} utcDateString
   * @returns
   */
  const formatUTCDateToLocal = (utcDateString) => {
    if (!utcDateString) return "--/--";

    const date = new Date(utcDateString);

    // Extract the time part from UTC (hereIignore timezone conversion)
    const utcHours = date.getUTCHours();
    const utcMinutes = date.getUTCMinutes();

    // Convert to 12-hour format
    const hours12 = utcHours % 12 || 12;
    const ampm = utcHours >= 12 ? "PM" : "AM";
    const minutesFormatted = String(utcMinutes).padStart(2, "0");

    // Format date part (optional - remove if you only want time)
    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = date.getUTCFullYear();

    return `${day}/${month}/${year} ${hours12}:${minutesFormatted} ${ampm}`;
  };

  const questionTypeOptions = [
    { value: "multiple_choice", text: "Multiple Choice" },
    { value: "true_false", text: "True / False" },
    { value: "checkbox", text: "Checkbox" }
  ];

  const normalizeTestQuestionForForm = (q) => ({
    question: q?.question ?? q?.question_text ?? "",
    type: q?.type ?? "",
    options: Array.isArray(q?.options) ? q.options.map((o) => (typeof o === "object" && o !== null && (o?.file_url || o?.text != null) ? o : (typeof o === "string" ? o : ""))) : [""],
    answer: Array.isArray(q?.answer) ? q.answer : (q?.answer != null ? [q.answer] : []),
    grade_point: q?.grade_point ?? 0,
    add_to_bank: q?.add_to_bank ?? false,
    id: q?.id ?? null,
    file: q?.file ?? {},
    required: q?.required ?? false,
    question_index: q?.question_index ?? 0
  });

  const handleOpenEditQuestionsModal = () => {
    const source = testDetailData?.questions ?? [];
    const normalized = source.length > 0 ? source.map(normalizeTestQuestionForForm) : [{
      question: "", type: "", options: [""], answer: [], grade_point: 0, add_to_bank: false, id: null, file: {}, required: false, question_index: 1
    }];
    setEditQuestionArr(normalized);
    setIsEditQuestionsModalOpen(true);
  };

  const editHandleQueChange = (e, index) => {
    const { name, value } = e.target;
    setEditQuestionArr((prev) => prev.map((q, i) => (i === index ? { ...q, [name]: value } : q)));
  };
  const editHandleQueTypeChange = (e, index) => {
    const { name, value } = e.target;
    setEditQuestionArr((prev) => prev.map((q, i) => {
      if (i !== index) return q;
      if (value === "true_false") return { ...q, [name]: value, options: ["True", "False"], answer: [] };
      const options = q.options?.length > 0 ? q.options : [""];
      return { ...q, [name]: value, options };
    }));
  };
  const editHandleQuePointChange = (e, index) => {
    const { name, value } = e.target;
    setEditQuestionArr((prev) => prev.map((q, i) => (i === index ? { ...q, [name]: value } : q)));
  };
  const editHandleCorrectChoiceChange = (e, index, queInd) => {
    const { checked, type } = e.target;
    setEditQuestionArr((prev) => {
      const next = [...prev];
      const q = next[queInd];
      if (!q) return prev;
      if (type === "radio") {
        next[queInd] = { ...q, answer: [index] };
        return next;
      }
      const answers = q.answer || [];
      if (checked) {
        next[queInd] = { ...q, answer: answers.includes(index) ? answers : [...answers, index] };
      } else {
        next[queInd] = { ...q, answer: answers.filter((i) => i !== index) };
      }
      return next;
    });
  };
  const editHandleMultipleChoiceChange = (e, optionIndex, questionIndex) => {
    const { value } = e.target;
    setEditQuestionArr((prev) => {
      const next = [...prev];
      const q = next[questionIndex];
      if (!q?.options) return prev;
      const newOptions = [...q.options];
      newOptions[optionIndex] = typeof newOptions[optionIndex] === "object" && newOptions[optionIndex] !== null ? { ...newOptions[optionIndex], text: value } : value;
      next[questionIndex] = { ...q, options: newOptions };
      return next;
    });
  };
  const editHandleAdditionalOptions = (queInd) => {
    setEditQuestionArr((prev) => {
      const next = [...prev];
      const q = next[queInd];
      const opts = q?.options?.length ? [...q.options, " "] : [" "];
      next[queInd] = { ...q, options: opts };
      return next;
    });
  };
  const editHandleAdditionalQuestion = () => {
    setEditQuestionArr((prev) => [
      ...prev,
      { question: "", type: "", options: [""], answer: [], grade_point: 0, id: null, file: {}, required: false, question_index: (prev?.length ?? 0) + 1 }
    ]);
  };
  const removeEditQuestion = (index) => {
    setEditQuestionArr((prev) => prev.filter((_, i) => i !== index));
  };
  const removeEditChoice = (optionIndex, queInd) => {
    setEditQuestionArr((prev) => {
      const next = [...prev];
      const q = next[queInd];
      if (!q?.options?.length) return prev;
      const newOptions = q.options.filter((_, i) => i !== optionIndex);
      next[queInd] = { ...q, options: newOptions.length ? newOptions : [""] };
      return next;
    });
  };
  const editHandleQueDescChange = (e, index) => {
    const { name, value } = e.target;
    setEditQuestionArr((prev) => prev.map((q, i) => (i === index ? { ...q, [name]: value } : q)));
  };
  const editHandleClick = (event, queInd) => {
    setEditAnchorEl(event.currentTarget);
    setCurrentAnchor(queInd);
  };
  const editHandleMenuClose = () => setEditAnchorEl(null);
  const editToggleQueDescriptionTrue = () => {
    setEditQuestionArr((prev) => {
      const next = [...prev];
      if (next[currentAnchor]) next[currentAnchor] = { ...next[currentAnchor], description: "" };
      return next;
    });
    editHandleMenuClose();
  };
  const editRemoveQueDescription = (index) => {
    setEditQuestionArr((prev) => prev.map((q, i) => {
      if (i !== index) return q;
      const rest = { ...q };
      delete rest.description;
      return rest;
    }));
  };

  const editHandleAddToBankChange = (e, index) => {
    const { checked } = e.target;
    setEditQuestionArr((prev) => prev.map((q, i) => (i === index ? { ...q, add_to_bank: checked } : q)));
  };

  const computeTotalGradeFromQuestions = (questionsList) => (questionsList || []).reduce((sum, q) => sum + (Number(q?.grade_point) || 0), 0);

  const buildTestPatchBody = (questionsPayload) => ({
    subject_id: testDetailData?.subject?.id,
    class_id: testDetailData?.class?.id,
    term_id: testDetailData?.term?.id,
    title: testDetailData?.title,
    description: testDetailData?.description ?? "",
    total_grade: computeTotalGradeFromQuestions(questionsPayload),
    instructions: testDetailData?.instruction ?? testDetailData?.instructions ?? "",
    test_date: testDetailData?.test_date,
    status: testDetailData?.status,
    questions: questionsPayload
  });

  const mapQuestionFormRowsToPayload = (arr) => {
    return (arr || []).map((q) => {
      const optionValues = (q.options || []).map((opt) => (typeof opt === "object" && opt !== null ? (opt?.text != null && opt.text !== "" ? opt.text : (opt?.file_url ? { file_url: opt.file_url, upload_id: opt.upload_id } : opt)) : opt));
      const item = {
        type: q.type,
        question_text: (q.question || "").trim(),
        options: optionValues,
        answer: Array.isArray(q.answer) ? q.answer : [],
        grade_point: Number(q.grade_point) || 0,
        add_to_bank: !!q.add_to_bank
      };
      if (q.id) item.id = q.id;
      return item;
    });
  };

  const handleUpdateTestQuestions = (nextStatus) => {
    if (!editQuestionsValidator.allValid()) {
      showEditQuestionsValidator(true);
      return;
    }
    const questionsPayload = mapQuestionFormRowsToPayload(editQuestionArr);
    const testConfigId = testDetailData?.test_config_id;

    if (nextStatus === "withdrawn" || nextStatus === "published") {
      if (!testConfigId) {
        toast.error("Test config not found. Cannot update questions.");
        return;
      }
      const setBusy = nextStatus === "published" ? setIsPublishingEditQuestions : setIsWithdrawingEditQuestions;
      setBusy(true);
      httprequest
        .post(`${TEST_CONFIG_ENDPOINT}${testConfigId}/save`, { status: nextStatus, questions: questionsPayload })
        .then(() => {
          setBusy(false);
          toast.success(nextStatus === "withdrawn" ? "Test withdrawn successfully." : "Test published successfully.");
          setIsEditQuestionsModalOpen(false);
          getTestByID();
        })
        .catch((err) => {
          setBusy(false);
          toast.error(err?.response?.data?.message ?? err?.response?.data ?? "Failed to update test.");
        });
      return;
    }

    if (!testConfigId) {
      toast.error("Test config not found. Cannot update questions.");
      return;
    }

    setIsUpdatingQuestions(true);
    httprequest
      .patch(`${TEST_CONFIG_ENDPOINT}${testConfigId}/questions`, { questions: questionsPayload })
      .then(() => {
        setIsUpdatingQuestions(false);
        toast.success("Questions updated successfully.");
        setIsEditQuestionsModalOpen(false);
        getTestByID();
      })
      .catch((err) => {
        setIsUpdatingQuestions(false);
        toast.error(err?.response?.data?.message ?? err?.response?.data ?? "Failed to update questions.");
      });
  };

  const buildSearchWithEditConfig = () => {
    const params = new URLSearchParams(location.search);
    params.delete("editConfig");
    const base = params.toString();
    return base ? `?${base}&editConfig` : "?editConfig";
  };

  const handleCloseMetadataDrawer = () => {
    const params = new URLSearchParams(location.search);
    params.delete("editConfig");
    const nextSearch = params.toString();
    navigate({ pathname: location.pathname, search: nextSearch ? `?${nextSearch}` : "" });
    setIsMetadataDrawerOpen(false);
  };

  const handleOpenMetadataDrawer = () => {
    setMetadataForm({
      title: testDetailData?.title ?? "",
      description: testDetailData?.description ?? "",
      instruction: testDetailData?.instruction ?? "",
      class_id: testDetailData?.class?.id ?? "",
      class_name: testDetailData?.class?.name ?? "",
      subject_id: testDetailData?.subject?.id ?? "",
      subject_name: testDetailData?.subject?.name ?? "",
      session_id: testDetailData?.session?.id ?? testDetailData?.term?.session_id ?? "",
      term_id: testDetailData?.term?.id ?? "",
      term_name: testDetailData?.term?.term ?? "",
      ca_type: testDetailData?.ca_type ?? "",
      duration: testDetailData?.duration ?? "",
      test_date: testDetailData?.test_date ? (typeof testDetailData.test_date === "string" ? testDetailData.test_date.substring(0, 16) : testDetailData.test_date) : "",
      random_question: testDetailData?.randomize_questions ? "yes" : "no",
      randomize_options: testDetailData?.randomize_options ? "yes" : "no",
      display_score_after_exam: testDetailData?.display_score_after_test_date ? "yes" : "no",
      question_display_mode: testDetailData?.questions_display_mode === "one_per_page" ? "one" : "all",
      proctoring_requirements: testDetailData?.proctoring_requirements ?? "",
      browser_lockdown: !!testDetailData?.browser_lockdown,
      is_private: !!testDetailData?.is_private
    });
    getSubjectsForClass(testDetailData?.class?.id);
    const selectedSessionId = testDetailData?.session?.id ?? testDetailData?.term?.session_id;
    if (selectedSessionId) {
      const found = allObtainableScores.find((item) => item?.session?.id === selectedSessionId);
      setObtainableScore(found || []);
    }
    setIsMetadataDrawerOpen(true);
  };

  useEffect(() => {
    const shouldOpen = searchParams.has("editConfig");
    if (shouldOpen && !isMetadataDrawerOpen && testDetailData && Object.keys(testDetailData).length > 0) {
      handleOpenMetadataDrawer();
    }
  }, [searchParams, testDetailData, isMetadataDrawerOpen]);

  const handleMetadataChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setMetadataForm((prev) => ({ ...prev, [name]: checked }));
      return;
    }
    if (name === "class_id") {
      const selectedClass = classData.find((item) => String(item?.id) === String(value));
      setMetadataForm((prev) => ({
        ...prev,
        class_id: value,
        class_name: selectedClass?.class_name || prev.class_name,
        subject_id: "",
        subject_name: ""
      }));
      getSubjectsForClass(value);
      return;
    }
    if (name === "subject_id") {
      const selectedSubject = allClassSubject.find((item) => String(item?.id) === String(value));
      setMetadataForm((prev) => ({
        ...prev,
        subject_id: value,
        subject_name: selectedSubject?.name || prev.subject_name
      }));
      return;
    }
    if (name === "session_id") {
      const selectedSessionId = value;
      const found = allObtainableScores.find((item) => String(item?.session?.id) === String(selectedSessionId));
      setObtainableScore(found || []);
      setMetadataForm((prev) => ({
        ...prev,
        session_id: selectedSessionId,
        term_id: "",
        term_name: "",
        ca_type: ""
      }));
      return;
    }
    if (name === "term_id") {
      const selectedTerm = allTerm.find((item) => String(item?.id) === String(value));
      setMetadataForm((prev) => ({
        ...prev,
        term_id: value,
        term_name: selectedTerm?.term || prev.term_name
      }));
      return;
    }
    setMetadataForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSaveTestConfig = () => {
    if (!editConfigValidator.allValid()) {
      showEditConfigValidator(true);
      return;
    }
    const body = buildTestPatchBody(testDetailData?.questions ?? []);
    Object.assign(body, {
      class_id: metadataForm.class_id || testDetailData?.class?.id,
      subject_id: metadataForm.subject_id || testDetailData?.subject?.id,
      session_id: metadataForm.session_id || testDetailData?.session?.id,
      term_id: metadataForm.term_id || testDetailData?.term?.id,
      ca_type: metadataForm.ca_type || null,
      title: metadataForm.title,
      description: metadataForm.description ?? "",
      instructions: metadataForm.instruction ?? "",
      duration: metadataForm.duration,
      test_date: metadataForm.test_date,
      randomize_questions: metadataForm.random_question === "yes",
      randomize_options: metadataForm.randomize_options === "yes",
      display_score_after_test_date: metadataForm.display_score_after_exam === "yes",
      questions_display_mode: metadataForm.question_display_mode === "one" ? "one_per_page" : "all_at_once",
      proctoring_requirements: metadataForm.proctoring_requirements || null,
      browser_lockdown: !!metadataForm.browser_lockdown,
      is_private: !!metadataForm.is_private
    });
    const configId = testDetailData?.test_config_id;
    httprequest
      .patch(`${TEST_CONFIG_ENDPOINT}${configId}`, body)
      .then(() => {
        toast.success("Test config updated.");
        setIsMetadataDrawerOpen(false);
        getTestByID();
      })
      .catch((err) => toast.error(err?.response?.data?.message ?? err?.response?.data ?? "Failed to update config."));
  };

  const handleOpenAddQuestionModal = () => {
    setAddQuestionArr([{ question: "", type: "", options: [""], answer: [], grade_point: 0, add_to_bank: false, id: null, file: {}, required: false, question_index: 1 }]);
    setIsAddQuestionModalOpen(true);
  };

  const addHandleQueChange = (e, index) => {
    const { name, value } = e.target;
    setAddQuestionArr((prev) => prev.map((q, i) => (i === index ? { ...q, [name]: value } : q)));
  };
  const addHandleQueTypeChange = (e, index) => {
    const { name, value } = e.target;
    setAddQuestionArr((prev) => prev.map((q, i) => {
      if (i !== index) return q;
      if (value === "true_false") return { ...q, [name]: value, options: ["True", "False"], answer: [] };
      const options = q.options?.length > 0 ? q.options : [""];
      return { ...q, [name]: value, options };
    }));
  };
  const addHandleQuePointChange = (e, index) => {
    const { name, value } = e.target;
    setAddQuestionArr((prev) => prev.map((q, i) => (i === index ? { ...q, [name]: value } : q)));
  };
  const addHandleCorrectChoiceChange = (e, index, queInd) => {
    const { checked, type } = e.target;
    setAddQuestionArr((prev) => {
      const next = [...prev];
      const q = next[queInd];
      if (!q) return prev;
      if (type === "radio") {
        next[queInd] = { ...q, answer: [index] };
        return next;
      }
      const answers = q.answer || [];
      if (checked) {
        next[queInd] = { ...q, answer: answers.includes(index) ? answers : [...answers, index] };
      } else {
        next[queInd] = { ...q, answer: answers.filter((i) => i !== index) };
      }
      return next;
    });
  };
  const addHandleMultipleChoiceChange = (e, optionIndex, questionIndex) => {
    const { value } = e.target;
    setAddQuestionArr((prev) => {
      const next = [...prev];
      const q = next[questionIndex];
      if (!q?.options) return prev;
      const newOptions = [...q.options];
      newOptions[optionIndex] = typeof newOptions[optionIndex] === "object" && newOptions[optionIndex] !== null ? { ...newOptions[optionIndex], text: value } : value;
      next[questionIndex] = { ...q, options: newOptions };
      return next;
    });
  };
  const addHandleAdditionalOptions = (queInd) => {
    setAddQuestionArr((prev) => {
      const next = [...prev];
      const q = next[queInd];
      const opts = q?.options?.length ? [...q.options, " "] : [" "];
      next[queInd] = { ...q, options: opts };
      return next;
    });
  };
  const addHandleAdditionalQuestion = () => {
    setAddQuestionArr((prev) => [
      ...prev,
      { question: "", type: "", options: [""], answer: [], grade_point: 0, add_to_bank: false, id: null, file: {}, required: false, question_index: (prev?.length ?? 0) + 1 }
    ]);
  };
  const removeAddQuestion = (index) => {
    setAddQuestionArr((prev) => prev.filter((_, i) => i !== index));
  };
  const removeAddChoice = (optionIndex, queInd) => {
    setAddQuestionArr((prev) => {
      const next = [...prev];
      const q = next[queInd];
      if (!q?.options?.length) return prev;
      const newOptions = q.options.filter((_, i) => i !== optionIndex);
      next[queInd] = { ...q, options: newOptions.length ? newOptions : [""] };
      return next;
    });
  };
  const addHandleQueDescChange = (e, index) => {
    const { name, value } = e.target;
    setAddQuestionArr((prev) => prev.map((q, i) => (i === index ? { ...q, [name]: value } : q)));
  };
  const [addAnchorEl, setAddAnchorEl] = useState(null);
  const addMenuOpen = Boolean(addAnchorEl);
  const addHandleClick = (event, queInd) => {
    setAddAnchorEl(event.currentTarget);
    setCurrentAnchor(queInd);
  };
  const addHandleMenuClose = () => setAddAnchorEl(null);
  const addToggleQueDescriptionTrue = () => {
    setAddQuestionArr((prev) => {
      const next = [...prev];
      if (next[currentAnchor]) next[currentAnchor] = { ...next[currentAnchor], description: "" };
      return next;
    });
    addHandleMenuClose();
  };
  const addRemoveQueDescription = (index) => {
    setAddQuestionArr((prev) => prev.map((q, i) => {
      if (i !== index) return q;
      const rest = { ...q };
      delete rest.description;
      return rest;
    }));
  };

  const addHandleAddToBankChange = (e, index) => {
    const { checked } = e.target;
    setAddQuestionArr((prev) => prev.map((q, i) => (i === index ? { ...q, add_to_bank: checked } : q)));
  };

  const handleSaveAddQuestions = (status) => {
    if (!addQuestionsValidator.allValid()) {
      showAddQuestionsValidator(true);
      return;
    }
    const testConfigId = testDetailData?.test_config_id;
    if (!testConfigId) {
      toast.error("Test config not found. Cannot save questions.");
      return;
    }
    setIsAddingQuestions(true);
    const newQuestionsPayload = mapQuestionFormRowsToPayload(addQuestionArr);
    const request = status === "draft"
      ? httprequest.patch(`${TEST_CONFIG_ENDPOINT}${testConfigId}/questions`, { questions: newQuestionsPayload })
      : httprequest.post(`${TEST_CONFIG_ENDPOINT}${testConfigId}/save`, { status: "published", questions: newQuestionsPayload });
    request
      .then(() => {
        setIsAddingQuestions(false);
        toast.success(status === "draft" ? "Saved as draft." : "Questions added.");
        setIsAddQuestionModalOpen(false);
        getTestByID();
      })
      .catch((err) => {
        setIsAddingQuestions(false);
        toast.error(err?.response?.data?.message ?? err?.response?.data ?? "Failed to add questions.");
      });
  };

  const testEditFooterMode = testDetailData?.status === "published"
    ? "published"
    : testDetailData?.status === "withdrawn"
      ? "withdrawn"
      : "draft";

  const isTestExpired = (testDetailData?.status || "").toLowerCase() === "expired";
  const testStatus = String(testDetailData?.status ?? "").trim().toLowerCase();
  const canGenerateQuestions = ["draft", "withdrawn", "empty", ""].includes(testStatus);

  const editModalContentProps = {
    editQuestionArr,
    classes,
    questionTypeOptions,
    editQuestionsValidator,
    isUpdatingQuestions,
    onQueChange: editHandleQueChange,
    onQueTypeChange: editHandleQueTypeChange,
    onQuePointChange: editHandleQuePointChange,
    onCorrectChoiceChange: editHandleCorrectChoiceChange,
    onMultipleChoiceChange: editHandleMultipleChoiceChange,
    onAdditionalOptions: editHandleAdditionalOptions,
    onAdditionalQuestion: editHandleAdditionalQuestion,
    onRemoveQuestion: removeEditQuestion,
    onRemoveChoice: removeEditChoice,
    onQueDescChange: editHandleQueDescChange,
    onMenuClick: editHandleClick,
    onMenuClose: editHandleMenuClose,
    onToggleDescription: editToggleQueDescriptionTrue,
    onRemoveDescription: editRemoveQueDescription,
    onAddToBankChange: editHandleAddToBankChange,
    editAnchorEl,
    editMenuOpen,
    showDraftAndCreateButtons: false,
    editFooterMode: testEditFooterMode,
    onEditUpdate: () => handleUpdateTestQuestions(),
    onEditPublish: () => handleUpdateTestQuestions("published"),
    onEditWithdraw: () => handleUpdateTestQuestions("withdrawn"),
    isEditUpdating: isUpdatingQuestions,
    isEditPublishing: isPublishingEditQuestions,
    isEditWithdrawing: isWithdrawingEditQuestions,
    hideAddQuestionInEdit: testDetailData?.status === "published",
    onQueImageChange: editImageHandlers.handleQuestionImageChange,
    onOptionImageChange: editImageHandlers.handleOptionImageChange,
    onRemoveQueImage: editImageHandlers.removeQueImage,
    onRemoveOptionImage: editImageHandlers.removeOptionImage,
    onIconClick: handleIconSharedClick,
    onIconOptionClick: handleIconSharedClick
  };

  const addModalContentProps = {
    editQuestionArr: addQuestionArr,
    classes,
    questionTypeOptions,
    editQuestionsValidator: addQuestionsValidator,
    isUpdatingQuestions: isAddingQuestions,
    onQueChange: addHandleQueChange,
    onQueTypeChange: addHandleQueTypeChange,
    onQuePointChange: addHandleQuePointChange,
    onCorrectChoiceChange: addHandleCorrectChoiceChange,
    onMultipleChoiceChange: addHandleMultipleChoiceChange,
    onAdditionalOptions: addHandleAdditionalOptions,
    onAdditionalQuestion: addHandleAdditionalQuestion,
    onRemoveQuestion: removeAddQuestion,
    onRemoveChoice: removeAddChoice,
    onQueDescChange: addHandleQueDescChange,
    onMenuClick: addHandleClick,
    onMenuClose: addHandleMenuClose,
    onToggleDescription: addToggleQueDescriptionTrue,
    onRemoveDescription: addRemoveQueDescription,
    onAddToBankChange: addHandleAddToBankChange,
    editAnchorEl: addAnchorEl,
    editMenuOpen: addMenuOpen,
    showDraftAndCreateButtons: true,
    onSaveDraft: () => handleSaveAddQuestions("draft"),
    onCreateTest: () => handleSaveAddQuestions("published"),
    primaryButtonLabel: "Publish",
    onQueImageChange: addImageHandlers.handleQuestionImageChange,
    onOptionImageChange: addImageHandlers.handleOptionImageChange,
    onRemoveQueImage: addImageHandlers.removeQueImage,
    onRemoveOptionImage: addImageHandlers.removeOptionImage,
    onIconClick: handleIconSharedClick,
    onIconOptionClick: handleIconSharedClick
  };

  /**
 * Effect hook that fetches test details or attendees based on the active tab.
 * @effect
 * @listens value
 */
  useEffect(() => {
    if (value === "1") {
      getTestByID();
    } else {
      getTestRecipients();
    }
  }, [value]);

  useEffect(() => {
    fetchClasses();
    getAllSessionAndTerms();
  }, [isTeacher]);

  /**
 * Exports test details to a Word document.
 * @throws {Error} When no test data is available.
 */
  const exportToWord = () => {
    if (!testDetailData || !testDetailData.questions) {
      toast.error("No test data available.");

      return;
    }

    let htmlContent = `
      <h1>${testDetailData.title || "Test Details"}</h1>
      <p><strong>Subject:</strong> ${testDetailData?.subject?.name || "--/--"}</p>
      <p><strong>Created By:</strong> ${`${testDetailData?.created_by?.last_name || "--/--"} ${testDetailData?.created_by?.first_name || "--/--"}`}</p>
      <p><strong>Created At:</strong> ${testDetailData?.created_at?.substring(0, 10) || "--/--"}</p>
      <p><strong>Test Date:</strong> ${testDetailData?.test_date?.substring(0, 10) || "--/--"}</p>
      <hr />
      <h2>Questions:</h2>
    `;

    testDetailData.questions.forEach((item, idx) => {
      htmlContent += `
        <div style="margin-bottom: 20px;">
          <h3>Q${questionDisplayIndex(item, idx, testDetailData.questions)}: ${item.question}</h3>
          ${item.file ? `<img src="${item.file.file_url}" width="200"/>` : ""}
          <ul>
            ${item.options.map((option) => {
    const content = typeof option === "object" && option.file_url
      ? `<img src="${option.file_url}" width="150"/>`
      : option;

    return `<li>${content}</li>`;
  }).join("")}
          </ul>
        </div>
      `;
    });

    const blob = HTMLDocx.asBlob(htmlContent);
    saveAs(blob, `${testDetailData.title || "test"}.docx`);
    setIsExportModalOpen(false);
    toast.success("CA Test Exported successfully");
  };

  /**
 * Toggles the export modal visibility state.
 */
  const handleExportModalToggle = () => {
    setIsExportModalOpen(!isExportModalOpen);
  };

  return (
    <Layout
      children={
        <>
          <div className="breadcrumb-container">
            <div>
              <BreadCrumb
                link_one="/assessment"
                link_one_name="CA Test"
                active={`${testDetailData?.subject?.name} Test`}
                description="See the details of this Test"
              />
            </div>
          </div>
          <div className="page-content">
            <PageTitle
              className={classes.inline}
              title={`${testDetailData?.title}`}
              subtitle={`Created By: ${`${testDetailData?.created_by?.last_name || "--/--"} ${testDetailData?.created_by?.first_name || "--/--"}`} || Class: ${testDetailData?.class?.name} `}
              button={
                <div className={classes.actionIconGroup}>
                  <Tooltip title="Export to Word" arrow placement="top">
                    <button
                      type="button"
                      className={classes.exportIconBtn}
                      onClick={handleExportModalToggle}
                      aria-label="Export to Word"
                    >
                      <Icon icon="flowbite:file-export-outline" width="22" height="22" />
                    </button>
                  </Tooltip>
                  <Tooltip title="Edit Test Config" arrow placement="top">
                    <button
                      type="button"
                      className={classes.exportIconBtn}
                      onClick={() => navigate({ pathname: location.pathname, search: buildSearchWithEditConfig() })}
                      aria-label="Edit Test Config"
                    >
                      <Icon icon="fluent:edit-16-regular" width="22" height="22" />
                    </button>
                  </Tooltip>
                  {canGenerateQuestions && (
                    <Tooltip title="Generate Questions" arrow placement="top">
                      <button
                        type="button"
                        className={classes.editIconBtn}
                        onClick={() => setIsGenerateDrawerOpen(true)}
                        aria-label="Generate Questions"
                      >
                        <Icon icon="fluent-color:bot-sparkle-16" width="22" height="22" />
                      </button>
                    </Tooltip>
                  )}
                </div>
              }
            />
            <TabContext value={value}>
              {testDetailData && Object.keys(testDetailData).length > 0 && (
                <div className="tablist-container">
                  <Tabs className="overide-tablist" onChange={handleChange} aria-label="">
                    <Tab label="Test Details" value="1" />
                    {/* <Tab label="Attendees" value="2" /> */}
                  </Tabs>
                </div>
              )}
              <TabPanel value="1" className="tabpanel-overide">
                <Grid container spacing={1}>
                  <div className="key-pair-container">
                    <Grid container spacing={1}>
                      <Grid item lg={3} md={3} sm={6} xs={12}>
                        <TestDetailCard title="Subject Name" subtitle={testDetailData?.subject?.name || "--/--"} />
                      </Grid>
                      <Grid item lg={3} md={3} sm={6} xs={12}>
                        <TestDetailCard title="Term" subtitle={testDetailData?.term?.term || "--/--"} />
                      </Grid>
                      <Grid item lg={3} md={3} sm={6} xs={12}>
                        <TestDetailCard title="Created By" subtitle={`${testDetailData?.created_by?.last_name || "--/--"} ${testDetailData?.created_by?.first_name || "--/--"}`} />
                      </Grid>
                      <Grid item lg={3} md={3} sm={6} xs={12}>
                        <TestDetailCard title="Created at" subtitle={testDetailData?.created_at?.substring(0, 10) || "--/--"} />
                      </Grid>
                      <Grid item lg={3} md={3} sm={6} xs={12}>
                        <TestDetailCard title="Title" subtitle={testDetailData?.title || "--/--"} />
                      </Grid>
                      <Grid item lg={3} md={3} sm={6} xs={12}>
                        <TestDetailCard title="Test Time" subtitle={formatUTCDateToLocal(testDetailData?.test_date) || "--/--"} />
                      </Grid>
                      <Grid item lg={3} md={3} sm={6} xs={12}>
                        <TestDetailCard title="Test Date" subtitle={testDetailData?.test_date?.substring(0, 10) || "--/--"} />
                      </Grid>
                      <Grid item lg={3} md={3} sm={6} xs={12}>
                        <TestDetailCard title="Updated At" subtitle={testDetailData?.updated_at?.substring(0, 10) || "--/--"} />
                      </Grid>
                      <Grid item lg={3} md={3} sm={6} xs={12}>
                        <TestDetailCard
                          title="Status"
                          subtitle={
                            <div className="subtitle-container">
                              {<Badge status={testDetailData?.status} /> || "--/--"}
                            </div>
                          }
                        />
                      </Grid>
                      <Grid item lg={3} md={3} sm={6} xs={12}>
                        <TestDetailCard title="Visibility" subtitle={testDetailData?.is_private ? "Private" : "Public"} />
                      </Grid>
                      <Grid item lg={2} md={4} sm={6} xs={12}>
                        <TestDetailCard title="Instruction" subtitle={testDetailData?.instruction || "--/--"} />
                      </Grid>
                    </Grid>
                  </div>
                  {/* <div className="key-pair-container">
                    <div className="key-pair-content">
                      <p className="key-pair-name">Status</p>
                      <h3 className="key-pair-value"> <Badge status={testDetailData?.status} /></h3>
                    </div>
                  </div> */}
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    {hasQuestions && (
                      <div style={{ marginBottom: 10 }}>
                        <WidgetTitle
                          title="Questions"
                          link={
                            testStatus !== "published" ? (
                              <Button
                                variant="primaryoutline"
                                color="btnfontprimary"
                                buttonSize="fluid"
                                onClick={handleOpenEditQuestionsModal}
                                buttonName="Edit questions"
                                disabled={isTestExpired}
                              />
                            ) : null
                          }
                        />
                      </div>
                    )}
                    {!hasQuestions ? (
                      <div style={{ minHeight: 280, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: 40 }}>
                        <NotFounditem
                          img={noexam}
                          title="No question has been added"
                          subtitle="Add questions for this test"
                        >
                          <Button
                            variant="primary"
                            color="btndefault"
                            buttonSize="fluid"
                            onClick={handleOpenAddQuestionModal}
                            buttonName="Add question"
                          />
                        </NotFounditem>
                      </div>
                    ) : !isEditQuestionsModalOpen ? (
                      <Grid container spacing={2}>
                      {testDetailData?.questions?.map((item, i) => {
                        const hasImageOption = item?.options?.some(option => typeof option === "object" && option.file_url);
                        const selectedAnswers = Array.isArray(item?.answer) ? item.answer : [];
                        const isSelectedOption = (optionIndex) => selectedAnswers.some((ans) => {
                          const numericAnswer = Number(ans);
                          return numericAnswer === optionIndex || numericAnswer === optionIndex + 1;
                        });

                        return (
                          <Grid item lg={4} md={6} sm={12} xs={12} key={i}>
                            <div className="question-preview-container">
                              <h3 className="question-preview-heading">
                                Question {questionDisplayIndex(item, i, testDetailData?.questions)}
                              </h3>
                              <div className={classes.question}>
                                <h3 className="question-preview-heading">
                                  {item?.question} {item?.required ? <span className="input-required">*</span> : null}
                                  {item?.file?.file_url ? (
                                    <div className={classes.quesdisplay}>
                                      <img src={item?.file?.file_url} alt="" />
                                    </div>
                                  ) : <div className={classes.displaynone}></div>}
                                </h3>

                                {(item?.type === "multiple_choice" || item?.type === "true_false") ? (
                                  hasImageOption ? (
                                    <Grid container spacing={2}>
                                      {item?.options?.map((option, i) => {
                                        const isImageOption = typeof option === "object" && option.file_url;

                                        return (
                                          <Grid item lg={6} md={6} sm={12} xs={12} key={i}>
                                            <div className="options-preview">
                                              <input type="radio" checked={isSelectedOption(i)} name={item?.question_index} disabled />
                                              {isImageOption ? (
                                                <div className={classes.optiondisplay}>
                                                  <img src={option.file_url} alt={`Option ${i + 1}`} />
                                                </div>
                                              ) : (
                                                <label>{option}</label>
                                              )}
                                            </div>
                                          </Grid>
                                        );
                                      })}
                                    </Grid>
                                  ) : (
                                    <>
                                      {item?.options?.map((option, i) => (
                                        <div key={i} className="options-preview">
                                          <input type="radio" checked={isSelectedOption(i)} name={item?.question_index} disabled />
                                          <label>{option}</label>
                                        </div>
                                      ))}
                                    </>
                                  )
                                ) : item?.type === "checkbox" ? (
                                  hasImageOption ? (
                                    <Grid container spacing={2}>
                                      {item?.options?.map((option, i) => {
                                        const isImageOption = typeof option === "object" && option.file_url;

                                        return (
                                          <Grid item lg={6} md={6} sm={12} xs={12} key={i}>
                                            <div className="options-preview">
                                              <input type="checkbox" checked={isSelectedOption(i)} name={item?.question_index} disabled />
                                              {isImageOption ? (
                                                <div className={classes.optiondisplay}>
                                                  <img src={option.file_url} alt={`Option ${i + 1}`} />
                                                </div>
                                              ) : (
                                                <label>{option}</label>
                                              )}
                                            </div>
                                          </Grid>
                                        );
                                      })}
                                    </Grid>
                                  ) : (
                                    <>
                                      {item?.options?.map((option, i) => (
                                        <div key={i} className="options-preview">
                                          <input type="checkbox" checked={isSelectedOption(i)} name={item?.question_index} disabled />
                                          <label>{option}</label>
                                        </div>
                                      ))}
                                    </>
                                  )
                                ) : null}
                              </div>
                            </div>
                          </Grid>
                        );
                      })}
                    </Grid>
                    ) : null}
                  </Grid>
                </Grid>
              </TabPanel>
              <TabPanel value="2">
                <Table data={attendeeFilter} columns={columns} subHeader={true} pagination subHeaderComponent={
                  testDetailData?.length > 0 && (
                    <TableSearch placeholder="Search here..." searchTableFunc={handleSearchTestByClass} />)

                }
                />
              </TabPanel>
            </TabContext>
            {/* <ToastContainer /> */}
          </div>
          {/* Send Report Modal */}
          <Modal
            title="Send Student Report"
            subtitle={
              <div>You are about to share the computed result sheets to the parent/guardian of Ojo William.
              </div>}
            modalContent={
              <>
                <Grid container spacing={2} className="input-padding">
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <InputGroup
                      label="Parent/Guardian Email"
                      margin="normal"
                      placeHolder="Enter guardian mail"
                      inputType="text"
                    />
                  </Grid>
                  <div className={`${classes.mail} flex align-items-center`}>
                    <Icon icon="fluent:mail-12-filled" width="24" height="24" />
                    <p>Use an alternative email</p>
                  </div>
                </Grid>
              </>
            }
            modalFooter={
              <>
                <div className={classes.modalFooterBtn}>
                  <Button variant="primaryoutline" buttonSize="full" color="btnfontprimary" buttonName="Cancel" />
                  <Button variant="primary" buttonSize="full" color="btndefault" buttonName="Send Report" />
                </div>
              </>
            }
            isopen={addreportModal}
            closeModal={handleReportModal}
          />
          {/* Send Broadcast Modal */}
          <Modal
            title="Message Parent/Guardian"
            subtitle={
              <div>Send a message to the parents of the students in this class
              </div>}
            modalContent={
              <>
                <Grid container spacing={2} className="input-padding">
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <InputGroup
                      label="Parent Name"
                      margin="normal"
                      placeHolder="Parent Name"
                      inputType="text"
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <InputGroup
                      label="Parent/Guardian Email"
                      margin="normal"
                      placeHolder="Parent Email"
                      inputType="email"
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <TextAreaGroup
                      label="Broadcast Message"
                      margin="normal"
                      placeholder="Enter the message you will like to share with the parents."
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <label className={`${classes.label}`}>Additional Information</label>
                    <div className={classes.pickercontainer}>
                      <input type="file" className={classes.picker} />

                      <div className={classes.uploadflex}>
                        <div><Icon icon="icon-park-outline:upload-two" className={classes.uploadicon} /></div>
                        <div>
                          <h2 className={classes.uploadtitle}>Tap to Upload</h2>
                          <h6 className={classes.uploadsubtitle}>SVG,PNG,JPG,GIF| 10MB max.</h6>
                        </div>
                      </div>
                      <div className={classes.rightpicker}>
                        <div className={classes.uploadbutton}>Upload</div>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </>
            }
            modalFooter={
              <>
                <div className={classes.modalFooterBtn}>
                  <Button variant="primaryoutline" buttonSize="full" color="btnfontprimary" buttonName="Cancel" />
                  <Button variant="primary" buttonSize="full" color="btndefault" buttonName="Broadcast" />
                </div>
              </>
            }
            isopen={messageModal}
            closeModal={handleMessageModal}
          />
          <Modal
            title="Export to Word"
            subtitle="Are you sure you want to export this CA Test to Word?"
            modalContent={<p>This will generate a Word document of this CA Test.</p>}
            modalFooter={
              <>
                <Button
                  variant="primary"
                  buttonSize="full"
                  color="btndefault"
                  buttonName="Confirm Export"
                  onClick={exportToWord}
                />
              </>
            }
            isopen={isExportModalOpen}
            closeModal={handleExportModalToggle}
          />
          <Modal
            fullScreen
            title="Add questions"
            subtitle="Add questions for this test, then save as draft or publish test."
            isopen={isAddQuestionModalOpen}
            closeModal={() => setIsAddQuestionModalOpen(false)}
            modalContent={<TestEditQuestionsModalContent {...addModalContentProps} />}
            modalFooter={null}
          />
          <Modal
            fullScreen
            title="Edit questions"
            subtitle="Update test questions. You can add more or remove questions."
            isopen={isEditQuestionsModalOpen}
            closeModal={() => setIsEditQuestionsModalOpen(false)}
            modalContent={<TestEditQuestionsModalContent {...editModalContentProps} />}
            modalFooter={null}
          />
          <RightDrawer
            open={isMetadataDrawerOpen}
            onClose={handleCloseMetadataDrawer}
            title="Edit Test Config"
          >
            <Grid container spacing={2}>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <InputGroup
                  label="Test Title"
                  inputName="title"
                  margin="normal"
                  inputType="text"
                  placeHolder="Enter title"
                  value={metadataForm.title}
                  onChange={handleMetadataChange}
                  required
                />
                {editConfigValidator.message("title", metadataForm.title?.trim(), "required")}
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <SelectGroup
                  label="Class"
                  children={
                    <select name="class_id" value={metadataForm.class_id} onChange={handleMetadataChange}>
                      <option value="">--- Select ---</option>
                      {classData?.map((clss) => (
                        <option key={clss?.id} value={clss?.id}>
                          {clss?.class_name}
                        </option>
                      ))}
                    </select>
                  }
                />
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <SelectGroup
                  label="Subject"
                  children={
                    <select name="subject_id" value={metadataForm.subject_id} onChange={handleMetadataChange}>
                      <option value="">--- Select ---</option>
                      {allClassSubject?.map((subject) => (
                        <option key={subject?.id} value={subject?.id}>
                          {subject?.name}
                        </option>
                      ))}
                    </select>
                  }
                />
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <SelectGroup
                  label="Session"
                  children={
                    <select name="session_id" value={metadataForm.session_id} onChange={handleMetadataChange}>
                      <option value="">--- Select ---</option>
                      {sessionData?.map((session) => (
                        <option key={session?.id} value={session?.id}>
                          {session?.session}
                        </option>
                      ))}
                    </select>
                  }
                />
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <SelectGroup
                  label="Term"
                  children={
                    <select name="term_id" value={metadataForm.term_id} onChange={handleMetadataChange}>
                      <option value="">--- Select ---</option>
                      {allTerm?.filter((term) => !metadataForm.session_id || String(term?.session_id) === String(metadataForm.session_id)).map((term) => (
                        <option key={term?.id} value={term?.id}>
                          {term?.term}
                        </option>
                      ))}
                      {metadataForm.term_id && !allTerm?.some((term) => String(term?.id) === String(metadataForm.term_id)) ? (
                        <option value={metadataForm.term_id}>{metadataForm.term_name || "Current Term"}</option>
                      ) : null}
                    </select>
                  }
                />
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <SelectGroup
                  label="CA Type"
                  children={
                    <select name="ca_type" value={metadataForm.ca_type} onChange={handleMetadataChange}>
                      <option value="">--- Select ---</option>
                      {obtainableScore?.ca?.map((ca, index) => (
                        <option key={index} value={ca?.ca_type}>
                          {ca?.ca_type}
                        </option>
                      ))}
                      {metadataForm.ca_type && !obtainableScore?.ca?.some((ca) => ca?.ca_type === metadataForm.ca_type) ? (
                        <option value={metadataForm.ca_type}>{metadataForm.ca_type}</option>
                      ) : null}
                    </select>
                  }
                />
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <TextAreaGroup
                  label="Description"
                  inputName="description"
                  margin="normal"
                  placeholder="Enter description"
                  value={metadataForm.description}
                  onChange={handleMetadataChange}
                />
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <TextAreaGroup
                  label="Instruction"
                  inputName="instruction"
                  margin="normal"
                  placeholder="Enter instruction"
                  value={metadataForm.instruction}
                  onChange={handleMetadataChange}
                />
              </Grid>
              <Grid item lg={12} md={6} sm={12} xs={12}>
                <InputGroup
                  label="Duration"
                  inputName="duration"
                  margin="normal"
                  inputType="number"
                  placeHolder="Duration (minutes)"
                  value={metadataForm.duration}
                  onChange={handleMetadataChange}
                />
              </Grid>
              <Grid item lg={12} md={6} sm={12} xs={12}>
                <InputGroup
                  label="Test Date"
                  inputName="test_date"
                  margin="normal"
                  inputType="datetime-local"
                  value={metadataForm.test_date}
                  onChange={handleMetadataChange}
                />
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <SelectGroup
                  label="Random Question"
                  children={
                    <select name="random_question" value={metadataForm.random_question} onChange={handleMetadataChange}>
                      <option value="yes">Yes</option>
                      <option value="no">No</option>
                    </select>
                  }
                />
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <SelectGroup
                  label="Randomize options"
                  children={
                    <select name="randomize_options" value={metadataForm.randomize_options} onChange={handleMetadataChange}>
                      <option value="yes">Yes</option>
                      <option value="no">No</option>
                    </select>
                  }
                />
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <SelectGroup
                  label="Display Score after Test"
                  children={
                    <select name="display_score_after_exam" value={metadataForm.display_score_after_exam} onChange={handleMetadataChange}>
                      <option value="yes">Yes</option>
                      <option value="no">No</option>
                    </select>
                  }
                />
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <SelectGroup
                  label="Question Display Mode"
                  children={
                    <select name="question_display_mode" value={metadataForm.question_display_mode} onChange={handleMetadataChange}>
                      <option value="">--- Select ---</option>
                      <option value="all">All at once</option>
                      <option value="one">One per page</option>
                    </select>
                  }
                />
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <SelectGroup
                  label="Proctoring requirements"
                  children={
                    <select name="proctoring_requirements" value={metadataForm.proctoring_requirements} onChange={handleMetadataChange}>
                      <option value="">--- Select ---</option>
                      <option value="none">None</option>
                      <option value="basic">Basic</option>
                      <option value="strict">Strict</option>
                    </select>
                  }
                />
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <label className={classes.enterque}>
                  <input
                    className="margin-top-5"
                    type="checkbox"
                    name="browser_lockdown"
                    checked={!!metadataForm.browser_lockdown}
                    onChange={handleMetadataChange}
                  />
                  {" "}Browser Lockdown
                </label>
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <label className={classes.enterque}>
                  <input
                    className="margin-top-5"
                    type="checkbox"
                    name="is_private"
                    checked={!!metadataForm.is_private}
                    onChange={handleMetadataChange}
                  />
                  {" "}Visibility (Private)
                </label>
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Button variant="primary" buttonSize="full" color="btndefault" buttonName="Save Config" onClick={handleSaveTestConfig} />
              </Grid>
            </Grid>
          </RightDrawer>
          <GenerateQuestionsDrawer
            open={isGenerateDrawerOpen}
            onClose={() => setIsGenerateDrawerOpen(false)}
            isAdmin={isAdmin}
            lessonOutlineId={location.state?.lessonOutline?.lesson_outline_id}
            versionId={location.state?.lessonOutline?.version_id}
            initialDestinationType="test"
            initialDestinationId={testDetailData?.test_config_id ?? id}
            examContext={{
              title: testDetailData?.title,
              subjectName: testDetailData?.subject?.name,
              subjectId: testDetailData?.subject?.id,
              classLabel: testDetailData?.class?.name,
              description: testDetailData?.description || ""
            }}
          />
          {/* <ToastContainer /> */}
        </>
      }
    />
  );
};

export default TestDetail;
